/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.TicketAttachmentResponse,
  (params: vp.TicketAttachmentRequest) => void,
  (params: vp.TicketAttachmentRequest) => Promise<vp.TicketAttachmentResponse>,
  () => void,
];

function usePostSubmitTicketAttachmentClient({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.TicketAttachmentRequest>();
  const [response, setResponse] = useState<vp.TicketAttachmentResponse>({
    Success: false,
    ErrorMessage: '',
    Response: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.TicketAttachmentRequest) => {
      setDataFetchingInfo(true, 'Your reply is being submitted', 'fullScreen');

      const res = await api.postSubmitTicketAttachment(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: vp.TicketAttachmentRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    (requestParams: vp.TicketAttachmentRequest) => api.postSubmitTicketAttachment(requestParams, source),
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Response: '',
      });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostSubmitTicketAttachmentClient);
